import { useEffect, useState } from 'react'
import { Button, Flex } from '@chakra-ui/react'

import { Plus } from 'components/icons'
import { differenceInDays } from 'date-fns'
import { americanDateParser } from 'utils/parsers/date'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'
import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'

export default function CalculoDeDiariasDoAGSUS() {
  const { questions, formMethods } = useCustomFormViewer()

  const { watch, setValue } = formMethods

  const [visibleExcerpt2, setVisibleExcerpt2] = useState(false)
  const [visibleExcerpt3, setVisibleExcerpt3] = useState(false)
  const [visibleExcerpt4, setVisibleExcerpt4] = useState(false)

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const trecho1Saida = watch ? watch(`form_answers.${titleForQuestion['Trecho 1 - Data da saída:']}`) : undefined
  const trecho1Chegada = watch ? watch(`form_answers.${titleForQuestion['Trecho 1 - Data da chegada:']}`) : undefined
  const trecho1Capital = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 1- Destino é capital ou demais localidades?']}`)
    : undefined
  const trecho1Parcial = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 1 - Valor da(s) diária(s)']}`)
    : undefined

  const trecho2Saida = watch ? watch(`form_answers.${titleForQuestion['Trecho 2 - Data da saída:']}`) : undefined
  const trecho2Chegada = watch ? watch(`form_answers.${titleForQuestion['Trecho 2 - Data da chegada:']}`) : undefined
  const trecho2Capital = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 2 - Destino é capital ou demais localidades?']}`)
    : undefined
  const trecho2Parcial = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 2 - Valor da(s) diária(s)']}`)
    : undefined

  const trecho3Saida = watch ? watch(`form_answers.${titleForQuestion['Trecho 3 - Data da saída:']}`) : undefined
  const trecho3Chegada = watch ? watch(`form_answers.${titleForQuestion['Trecho 3 - Data da chegada:']}`) : undefined
  const trecho3Capital = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 3 - Destino é capital ou demais localidades?']}`)
    : undefined
  const trecho3Parcial = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 3 - Valor da(s) diária(s)']}`)
    : undefined

  const trecho4Saida = watch ? watch(`form_answers.${titleForQuestion['Trecho 4 - Data da saída:']}`) : undefined
  const trecho4Chegada = watch ? watch(`form_answers.${titleForQuestion['Trecho 4 - Data da chegada:']}`) : undefined
  const trecho4Capital = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 4 - Destino é capital ou demais localidades?']}`)
    : undefined
  const trecho4Parcial = watch
    ? watch(`form_answers.${titleForQuestion['Trecho 4 - Valor da(s) diária(s)']}`)
    : undefined

  useEffect(() => {
    if (trecho1Saida?.length == 10 && trecho1Chegada?.length == 10 && trecho1Capital) {
      const totalDays = differenceInDays(
        new Date(americanDateParser(trecho1Chegada)),
        new Date(americanDateParser(trecho1Saida))
      )
      const amountDay = trecho1Capital == 'Capital' ? 280 : 200
      // const amountTotal = (totalDays - 1) * amountDay + amountDay / 2
      const amountTotal = totalDays * amountDay + amountDay / 2
      setValue(`form_answers.${titleForQuestion['Trecho 1 - Valor da(s) diária(s)']}`, amountTotal.toString())
    }
  }, [trecho1Saida, trecho1Chegada, trecho1Capital])

  useEffect(() => {
    if (trecho2Saida?.length == 10 && trecho2Chegada?.length == 10 && trecho2Capital) {
      const totalDays = differenceInDays(
        new Date(americanDateParser(trecho2Chegada)),
        new Date(americanDateParser(trecho2Saida))
      )
      const amountDay = trecho2Capital == 'Capital' ? 280 : 200
      // const amountTotal = (totalDays - 1) * amountDay + amountDay / 2
      const amountTotal = totalDays * amountDay + amountDay / 2
      setValue(`form_answers.${titleForQuestion['Trecho 2 - Valor da(s) diária(s)']}`, amountTotal.toString())
    }
  }, [trecho2Saida, trecho2Chegada, trecho2Capital])

  useEffect(() => {
    if (trecho3Saida?.length == 10 && trecho3Chegada?.length == 10 && trecho3Capital) {
      const totalDays = differenceInDays(
        new Date(americanDateParser(trecho3Chegada)),
        new Date(americanDateParser(trecho3Saida))
      )
      const amountDay = trecho3Capital == 'Capital' ? 280 : 200
      // const amountTotal = (totalDays - 1) * amountDay + amountDay / 2
      const amountTotal = totalDays * amountDay + amountDay / 2
      setValue(`form_answers.${titleForQuestion['Trecho 3 - Valor da(s) diária(s)']}`, amountTotal.toString())
    }
  }, [trecho3Saida, trecho3Chegada, trecho3Capital])

  useEffect(() => {
    if (trecho4Saida?.length == 10 && trecho4Chegada?.length == 10 && trecho4Capital) {
      const totalDays = differenceInDays(
        new Date(americanDateParser(trecho4Chegada)),
        new Date(americanDateParser(trecho4Saida))
      )
      const amountDay = trecho4Capital == 'Capital' ? 280 : 200
      // const amountTotal = (totalDays - 1) * amountDay + amountDay / 2
      const amountTotal = totalDays * amountDay + amountDay / 2
      setValue(`form_answers.${titleForQuestion['Trecho 4 - Valor da(s) diária(s)']}`, amountTotal.toString())
    }
  }, [trecho4Saida, trecho4Chegada, trecho4Capital])

  useEffect(() => {
    const p_1 = Number(trecho1Parcial) || 0
    const p_2 = Number(trecho2Parcial) || 0
    const p_3 = Number(trecho3Parcial) || 0
    const p_4 = Number(trecho4Parcial) || 0
    let total = p_1 + p_2 + p_3 + p_4

    if (trecho4Capital) {
      const isCapital = trecho4Capital == 'Capital'
      if (isCapital) {
        total = total - 140
      } else {
        total = total - 100
      }
    } else if (trecho3Capital) {
      const isCapital = trecho3Capital == 'Capital'
      if (isCapital) {
        total = total - 140
      } else {
        total = total - 100
      }
    } else if (trecho2Capital) {
      const isCapital = trecho2Capital == 'Capital'
      if (isCapital) {
        total = total - 140
      } else {
        total = total - 100
      }
    } else if (trecho1Capital) {
      const isCapital = trecho1Capital == 'Capital'
      if (isCapital) {
        total = total - 140
      } else {
        total = total - 100
      }
    } else {
      total = total
    }

    setValue(`form_answers.${titleForQuestion['Valor total das diárias:']}`, total.toString())
  }, [trecho1Parcial, trecho2Parcial, trecho3Parcial, trecho4Parcial])

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2}>
      {questions.map((question, index) => {
        const questionAboutExcerpt = question.title?.includes('Trecho')
        const match = question.title?.match(/Trecho (\d+) -/)
        let number = null

        if (questionAboutExcerpt) {
          if (match) {
            number = parseInt(match[1], 10)
          }
        }

        if (number == 2 && !visibleExcerpt2) {
          if (question.title == 'Trecho 2 - Destino:') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleExcerpt2(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar trecho 2
              </Button>
            )
          } else {
            return <></>
          }
        }

        if (number == 3 && !visibleExcerpt3) {
          if (question.title == 'Trecho 3 - Destino:' && visibleExcerpt2) {
            return (
              <Button
                key={index}
                onClick={() => setVisibleExcerpt3(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar trecho 3
              </Button>
            )
          } else {
            return <></>
          }
        }

        if (number == 4 && !visibleExcerpt4) {
          if (question.title == 'Trecho 4 - Destino:' && visibleExcerpt3) {
            return (
              <Button
                key={index}
                onClick={() => setVisibleExcerpt4(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar trecho 4
              </Button>
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
